import {BasicEntity} from '../../framework/message/BasicEntity';

export class EntityModification extends BasicEntity {
emTime: number | null;
entityClass: number;
entityId: number | null;
entityUID: string;
fullParentEntity: number | null;
login: string;
newValueJson: Object;
oldValueJson: Object;
order: number | null;
packUID: string;
path: string;
range: string;
refCode: string;
refField: string;
visionCode: string;
}

